<template>
  <section class="container mx-auto p-2 w-full">
    <div class="w-full bg-coral-100 p-4 my-4 lg:my-16 font-semibold text-primary flex items-center text-xl">
      <LockOpenIcon />&nbsp;
      <p>Unlocked Tasks</p>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 justify-center items-center gap-8 px-2 mb-4 lg:mb-12">
      <div v-for="campaign in unlockedCampaigns" :key="campaign.id">
        <a :href="`campaigns/${campaign.slug}`">
          <CreateContentTaskCard :campaign="campaign" :locked="false" class="lg:w-full" />
        </a>
      </div>
    </div>

    <div
      v-if="lockedCampaigns.length > 0"
      class="w-full bg-coral-100 p-4 my-4 lg:my-16 font-semibold text-primary flex items-center text-xl"
    >
      <LockIcon />&nbsp;
      <p>Locked Paid Tasks</p>
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-3 justify-center items-center gap-8 px-2 mb-4 lg:mb-12">
      <div v-for="campaign in lockedCampaigns" :key="campaign.id">
        <CreateContentTaskCard :campaign="campaign" :locked="true" class="lg:w-full" />
      </div>
    </div>
  </section>
</template>

<script>
import CreateContentTaskCard from './CreateContentTaskCard.vue';

export default {
  name: 'CreateContentComponent',
  components: { CreateContentTaskCard },
  props: ['user', 'unlockedCampaigns', 'lockedCampaigns'],
};
</script>
